import React, { useState, useEffect } from 'react';
import Logo from '../assets/logo.png';
import {
    Home as HomeIcon,
    LayoutGrid,
    Heart,
    Settings,
    LogOut
} from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';
import MobileNav from './MobileNav';
import LogoutButton from './LogoutButton';


export default function Sidebar() {

    const [isMobile, setIsMobile] = useState(false);

    
    const checkIfMobile = () => {
        if (window.innerWidth <= 768) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => {
            window.removeEventListener('resize', checkIfMobile);
        };
    }, []);



    const navItems = [
        { label: 'Home', icon: <HomeIcon size={20} />, path: 'home' },
        { label: 'Categories', icon: <LayoutGrid size={20} />, path: 'categories' },
        { label: 'Favorites', icon: <Heart size={20} />, path: 'favorites' },
        { label: 'Settings', icon: <Settings size={20} />, path: 'settings' }
    ];

    const navigate = useNavigate();




   if(isMobile){
    return(
        <MobileNav/>
    )
   }



    return (

            <div className="sidebar bg-white shadow d-flex flex-column justify-content-between" style={{ width: '250px', height: '100vh' }}>
                <div>
                    <div className="text-center mb-5">
                        <img src={Logo} alt="Logo" className="img-fluid" style={{ maxHeight: '60px' }} />
                    </div>

                    <ul className="list-unstyled sidebar-menu mt-5">
                        {navItems.map(item => (
                            <li key={item.path} className="mb-3">
                                <NavLink to={`/dashboard/${item.path}`}
                                    className={({ isActive }) =>
                                        `position-relative d-flex align-items-center 
                            gap-2 px-2 py-1 sidebar-item text-decoration-none 
                            rounded ${isActive ? 'sidebar-active' : ''
                                        }`
                                    }
                                >
                                    {({ isActive }) => (
                                        <>
                                            {isActive && (
                                                <div
                                                    className="position-absolute start-0 top-0 bottom-0 d-flex align-items-center"
                                                    style={{
                                                        width: '8px',
                                                        backgroundColor: 'var(--main-red)',
                                                        borderRadius: '0 6px 6px 0',
                                                        left: '-12px'
                                                    }}
                                                />
                                            )}
                                            {item.icon}
                                            <span>{item.label}</span>
                                        </>
                                    )}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>

               <div className='w-100 p-2'
                style={{display:'flex' , flexDirection:'column' , alignItems:'stretch'}} >
                <LogoutButton/>
               </div>
            </div>
    );
}
